/**
 * RestoID — Enterprise SSO landing (first screen).
 * ---------------------------------------------------------------------------
 * RestoID frame around `SsoEmailForm` — RestoID's own email field and CTA on the
 * PRISTINE upstream SSO logic. Guard mirrors the upstream page (SSO disabled ->
 * /sign-in). Swapped in via `src/App.tsx`.
 */
import { AgreeToTermsPolicy, experience } from '@logto/schemas';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import FirstScreenLayout from '@/Layout/FirstScreenLayout';
import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import { useSieMethods } from '@/hooks/use-sie';
import useTerms from '@/hooks/use-terms';

import SsoEmailForm from '../components/SsoEmailForm';
import { LinkText, ScreenHead, Stack } from '../components/restoid';
import { useCopy } from '../copy';

const SingleSignOnLanding = () => {
  const { t } = useTranslation();
  const c = useCopy();
  const navigate = useNavigateWithPreservedSearchParams();
  const { singleSignOnEnabled } = useSieMethods();
  const { agreeToTermsPolicy } = useTerms();

  if (!singleSignOnEnabled) {
    return <Navigate to={`/${experience.routes.signIn}`} />;
  }

  return (
    <FirstScreenLayout pageMeta={{ titleKey: 'action.single_sign_on' }}>
      <Stack gap={22}>
        <ScreenHead
          title={t('action.single_sign_on')}
          sub={t('description.single_sign_on_email_form')}
        />
        <SsoEmailForm
          isTermsAndPrivacyCheckboxVisible={agreeToTermsPolicy === AgreeToTermsPolicy.Manual}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <LinkText onClick={() => navigate(`/${experience.routes.signIn}`)}>
            {c('allOptions')}
          </LinkText>
        </div>
      </Stack>
    </FirstScreenLayout>
  );
};

export default SingleSignOnLanding;
